<template>
           <ul id="progressbar">  
            <template v-for="(item, index) in items" :key="item">
                    <li :class="{'active': isActive(index)}" :id="'step'+(index+1)">  
                        {{item.label}}
                        <template v-if="index==0">
                           <br/> {{creator}}
                        </template>
                        <template v-else-if="index==1">
                           <br/> {{sourcer}}
                        </template>
                        <template v-else-if="index==2">
                           <br/> {{addMember}}
                        </template>
                        <template v-else-if="index==3">
                           <br/> {{manager}}
                        </template>
                       
                    </li>  
            
            </template>
                  
            </ul>  
</template>  
<script>


export default {
    props: ["stepId","creator","sourcer","manager","addMember"],
    components: {

    },
    data() {
        return {
            items: [
                { label: '申請', to: '', class: 'green_item', style: 'font-weight:bolder;font-size:large' },
                { label: 'Sourcer', to: '', class: 'white_item', style: 'font-weight:bolder;font-size:large' },
                { label: '會簽', to: '', class: 'white_item', style: 'font-weight:bolder;font-size:large' },
                { label: '主管', to: '', class: 'white_item', style: 'font-weight:bolder;font-size:large' }
            ],
         
        }
    },
    Service: null,
    EFormService: null,
    created() {
        this.ShowStep();
       
    },
    watch: {
        stepId: function () {
              // watch it
             //("Prop changed: ", newVal, " | was: ", oldVal);
              this.ShowStep();
            },
            
          },
    computed: {
      
    },
   methods: {
    isCompleted(index) {
             return this.stepId>index;
        },
    isActive(index) {
             return this.stepId==index;
        },
         onWizardComplete(){

    },
  
        
    onWizardChange(prevIndex, nextIndex){
      //console.log(prevIndex)
      //console.log(nextIndex)
      this.pageIndex=nextIndex;
 
    },
            ShowStep() {
                //sourcer
                if (this.stepId == 1) {
                    this.items[1].class = 'yellow_item'
                    this.items[2].class = 'white_item'
                    this.items[3].class = 'white_item'
                }
                //會簽            
                if (this.stepId == 2) {
                    this.items[1].class = 'green_item'
                    this.items[2].class = 'yellow_item'
                    this.items[3].class = 'white_item'
                }
                //主管
                if (this.stepId == 3) {
                    this.items[1].class = 'green_item'
                    this.items[2].class = 'green_item'
                    this.items[3].class = 'yellow_item'
                }
            },
        }
    }
</script>
  

<style scoped> 

#progressbar {  
    margin-bottom: 30px;  
    overflow: hidden;  
    color: lightgrey  
}  
#progressbar .active {  
    color: #2F8D46  
}  
#progressbar li {  
    list-style-type: none;  
    font-size: 15px;  
    width: 25%;  
    float: left;  
    position: relative;  
    font-weight: 400  
}  
#progressbar #step1:before {  
    content: "1"  
}  
#progressbar #step2:before {  
    content: "2"  
}  
#progressbar #step3:before {  
    content: "3"  
}  
#progressbar #step4:before {  
    content: "4"  
}  
#progressbar li:before {  
    width: 50px;  
    height: 50px;  
    line-height: 45px;  
    display: block;  
    font-size: 20px;  
    color: #ffffff;  
    background: lightgray;  
    border-radius: 50%;  
    margin: 0 auto 10px auto;  
    padding: 2px  
}  
#progressbar li:after {  
    content: '';  
    width: 100%;  
    height: 2px;  
    background: lightgray;  
    position: absolute;  
    left: 0;  
    top: 25px;  
    z-index: -1  
}  
#progressbar li.active:before  
{  
    background: #2F8D46  
}  
#progressbar li.active:after {  
    background: #2F8D46  
}  
#progressbar li.active:after {  
    background: #2F8D46  
}  
</style>